import axios from '../axios';
import { Normalize } from '../phone';
import * as models from './models';
import { GetPageRequestID } from './pagerequests';
import { Session } from './session';

export function UserTaxExemptions(hyejooRequestInit?: models.IHyejooRequest): Promise<models.UserTaxExemptionsHyejooResponse> {
    return axios.get('/user-tax-exemptions', {
        params: new models.HyejooRequest(hyejooRequestInit),
    }).then(resp => models.UserTaxExemptionsHyejooResponse.fromJSON(resp.data));
}

export declare interface NewUserTaxExemptionOptions {
    user: models.IUser;
    userTaxExemptReasonID: number;
    number: string;
    countryID: number;
    stateID?: number;
    uploadIDs: number[];
    label?: string;
}

export async function NewUserTaxExemption(opts: NewUserTaxExemptionOptions): Promise<models.UserTaxExemption> {
    const user = new models.User(opts.user);
    user.tz ??= Intl.DateTimeFormat().resolvedOptions().timeZone;
    user.pageRequestID ??= await GetPageRequestID();
    user.phone = Normalize(user.phone);

    // Backfill from the active session — UserTaxExemption has no email/phone
    // of its own, so the session is the only fallback when callers lose
    // user.email/phone (the customer-api requires both).
    if (!user.email || !user.phone) {
        const sess = await Session().catch(() => undefined);
        if (!user.email && sess?.user.emailAddress.email) {
            user.email = sess.user.emailAddress.email;
        }
        if (!user.phone && sess?.user.phoneNumber.phone) {
            user.phone = Normalize(sess.user.phoneNumber.phone);
        }
    }

    return axios.post('/user-tax-exemptions', { ...opts, user }).
        then(resp => models.UserTaxExemption.fromJSON(resp.data));
}

export function DeleteUserTaxExemption(userTaxExemptionID: string) {
    return axios.delete(`/user-tax-exemptions/${userTaxExemptionID}`);
}

export function RestoreUserTaxExemption(userTaxExemptionID: string) {
    return axios.patch(`/user-tax-exemptions/${userTaxExemptionID}`, { 'active': true });
}

export function UpdateUserTaxExemptionLabel(userTaxExemptionID: string, label: string) {
    return axios.patch(`/user-tax-exemptions/${userTaxExemptionID}`, { 'label': label });
}
